import { ApiError } from "@/lib/api/api-error";
import { AgentGatewayService } from "@/services/agent-gateway-service";
import { queryOptions } from "@tanstack/react-query";

export const agentGatewayQueryKeys = {
  all: ["agent-gateway"] as const,
  availableAgents: () =>
    [...agentGatewayQueryKeys.all, "available-agents"] as const,
  sessions: (agentKey: string) =>
    [...agentGatewayQueryKeys.all, "sessions", agentKey] as const,
  session: (agentKey: string, sessionId: string) =>
    [...agentGatewayQueryKeys.sessions(agentKey), sessionId] as const,
};

function retryAgentGatewayQuery(failureCount: number, error: Error) {
  if (error instanceof ApiError && [401, 403, 404].includes(error.status)) {
    return false;
  }

  return failureCount < 2;
}

export function availableAgentsQueryOptions() {
  return queryOptions({
    queryKey: agentGatewayQueryKeys.availableAgents(),
    queryFn: () => AgentGatewayService.listAvailableAgents(),
    staleTime: 60 * 1000,
    retry: retryAgentGatewayQuery,
  });
}

export function agentSessionsQueryOptions(agentKey: string) {
  return queryOptions({
    queryKey: agentGatewayQueryKeys.sessions(agentKey),
    queryFn: () => AgentGatewayService.listSessions(agentKey),
    retry: retryAgentGatewayQuery,
  });
}

export function agentSessionQueryOptions(agentKey: string, sessionId: string) {
  return queryOptions({
    queryKey: agentGatewayQueryKeys.session(agentKey, sessionId),
    queryFn: () => AgentGatewayService.getSession(agentKey, sessionId),
    retry: retryAgentGatewayQuery,
  });
}
